// reqpurchase 워크플로우에서 처리 결과로 박히는 휘발성 필드 일괄 리셋용 mixin
// copyReq / copyRequest / addlists / 엑셀 대량주문 등 새 요청을 만드는 경로에서 사용
// 어드민(logisreqpurchaseV0) 처리 결과(결제완료/입금완료/주문생성 등)가 다음 요청에 잔존하지 않도록 차단

const VOLATILE_FIELDS = [
  // 처리 상태
  'processStatus',
  '견적서상태',
  '최종결제여부',
  '최종결제시간',
  '물류정보',
  // 견적서/결제
  '견적서_1688구매금액',
  '견적서_중국물류비',
  '견적서_한국물류비',
  '입금여부',
  '입금일시',
  '입금은행내역',
  '입금확인일',
  '결제일',
  '발송일',
  '알림톡발송여부',
  // 주문/구매
  '주문정보',
  '주문생성여부',
  '주문시간',
  '화주주문번호',
  '상품주문번호',
  '구매완료수량',
  '구매취소',
  '구매취소내용',
  '별도결제',
  // 입고
  '입고완료수량',
  '입고오류상세',
  '입고오류유형',
  '입고수량',
  '입고날짜',
  // 박스배정/분할 (입고처리·박스배정 처리 결과 — 복사/재요청 시 잔존 금지)
  '출고정보',
  'splitGroupId',
  '원구매요청수량',
  // 이력
  'changeHistory',
  'statusHistory',
  'processHistory'
]

export default {
  methods: {
    resetReqVolatileFields (obj) {
      if (!obj || typeof obj !== 'object') return
      obj.진행현황 = '구매전'
      obj.구매id = ''
      VOLATILE_FIELDS.forEach(f => { delete obj[f] })
    }
  }
}
